module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#business",
      toString: function () {
        return this.url;
      }
    }